import { HeaderQueryResult } from "@/cms/sanity.types";

// Derive the union type of entries inside linkGroup
type MenuEntry = NonNullable<
  NonNullable<NonNullable<HeaderQueryResult>["linkGroup"]>
>[number];

// Type guard: checks if a menu entry is a submenu (has _type === 'submenuLinks')
export function isSubmenuEntry(
  entry: MenuEntry,
): entry is Extract<MenuEntry, { _type: "submenuLinks" }> {
  return (entry as { _type?: string })._type === "submenuLinks";
}

// Type guard: checks if a menu entry is a single link item (not a submenu)
export function isSingleLinkEntry(
  entry: MenuEntry,
): entry is Exclude<MenuEntry, { _type: "submenuLinks" }> {
  return (entry as { _type?: string })._type !== "submenuLinks";
}

/** Shared so submenu triggers and single links get an identical underline. */
export const MENU_UNDERLINE_CLASS =
  "hover:underline hover:decoration-[var(--cvr-submenu-background,#333333)] hover:decoration-2 hover:underline-offset-2 focus-visible:underline focus-visible:decoration-[var(--cvr-submenu-background,#333333)] focus-visible:decoration-2 focus-visible:underline-offset-2";
